import Splide from '@splidejs/splide';

document.addEventListener("DOMContentLoaded", function () {
    const sliderElements = document.querySelectorAll('.cards-image-block__slider');

    sliderElements.forEach((sliderElement) => {
        let cardsimage__slider;

        function initializeSplide() {
            if (!sliderElement.splide) {
                cardsimage__slider = new Splide(sliderElement, {
                    type: 'loop',
                    perPage: 3,
                    perMove: 1,
                    gap: '30px',
                    arrows:true,
                    pagination: false,
                    focus: 'center', // Keeps the center slide fully visible
                    breakpoints: {
                        1024: {
                            perPage: 2, // Show 2 full slides with peeking
                            padding: { right: '5%', left: '5%' },
                        },
                        667: {
                            perPage: 1, // Show 1 full slide with strong peeking
                            padding: { right: '15%', left: '15%' },
                            gap: '10px',
                        },
                    },
                });
                cardsimage__slider.mount();
                sliderElement.splide = cardsimage__slider;
            }
        }

        initializeSplide();
        window.addEventListener('resize', initializeSplide);
    });
});

